import React, { useState } from "react";
import { Form, Button, Descriptions, Select, Input } from "antd";
import { ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment, ApplicantUserPersonalInformationInput, Entity } from "../../../../generated";
import { MinusCircleOutlined } from "@ant-design/icons";

export interface ProfileApplyToEditProps {
  data: ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment;
  entities: Entity[];
  onEditToggle: () => void;
  onSave: (input: ApplicantUserPersonalInformationInput) => Promise<void>;
}

export const ProfileApplyToEdit: React.FC<ProfileApplyToEditProps> = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm<ApplicantUserPersonalInformationInput>();
  const [formLoading, setFormLoading] = React.useState(false);

  const initialValues = {
    applyingTo: props.data?.personalInformation?.applyingTo?.map((applyingToEntity) => props.entities.find((entity) => entity.id === applyingToEntity?.id)?.id) || [],
  };

  const MAX_FILES = 5;
  return (
    <div>
      <Form
        layout="vertical"
        className="w-[85%] md:w-[400px]"
        form={form}
        initialValues={initialValues}
        onFinish={async (values) => {
          setIsSubmitting(true);
          setFormLoading(true);
          await props.onSave(values);
          setIsSubmitting(false);
          setFormLoading(false);
        }}
      >
        <Descriptions title="Organizations to where I'm applying" layout="vertical" size="small" column={1} className=" pl-8">
          <Descriptions.Item label="Recipients for the Verification Status Report">&nbsp;</Descriptions.Item>
        </Descriptions>
        <Form.List
          name="applyingTo"
          rules={[
            {
              validator: async (_, applyingTo) => {
                if (!applyingTo || applyingTo.length < 1) {
                  return Promise.reject(new Error("Please select at least one organization"));
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <div key={field.key} style={{ marginBottom: "15px" }}>
                  <div
                    style={{
                      display: "inline-block",
                      verticalAlign: "top",
                      paddingRight: "10px",
                    }}
                  >
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => {
                        if (fields.length != 1) {
                          remove(field.name);
                        }
                      }}
                      disabled={props.data?.personalInformation?.applyingTo?.length === 1 && fields.length === 1}
                    />
                  </div>
                  <div
                    style={{
                      display: "inline-block",
                      paddingTop: "3px",
                      paddingLeft: "10px",
                      borderLeft: "1px solid darkgrey",
                    }}
                  >
                    <Form.Item name={[index, "id"]} hidden={true}>
                      <Input hidden={true} />
                    </Form.Item>
                    <Form.Item
                      key={field.key}
                      name={field.name}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          message: "Please input the organization's name or delete this field.",
                        },
                        {
                          validator: async (_, value: string) => {
                            const selectedValues = form.getFieldValue("applyingTo");
                            if (selectedValues && selectedValues.filter((val: string) => val === value).length > 1) {
                              return Promise.reject(new Error("Duplicate selection is not allowed"));
                            }
                          },
                        },
                      ]}
                    >
                      <Select style={{ width: 200 }}>
                        {props.entities.map((entity) => (
                          <Select.Option key={entity.id} value={entity.id}>
                            {entity.entityName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              ))}
              {fields.length < MAX_FILES ? (
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => {
                      add();
                    }}
                    block
                    style={{ width: "90%", paddingRight: "10px" }}
                    disabled={fields.length === props.entities.length}
                  >
                    Add Additional Entity
                  </Button>
                </Form.Item>
              ) : (
                <></>
              )}
            </>
          )}
        </Form.List>
        <div className="flex items-center justify-end gap-4 w-full">
          <Button onClick={props.onEditToggle} disabled={isSubmitting}>
          Cancel
          </Button>
          <Button htmlType="submit" value={"save"} disabled={isSubmitting} loading={formLoading} type="primary">
            Save
          </Button>
        </div>
      </Form>
    </div>
  );
};
